import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { LiftsService } from "@app/lift/service/lifts.service";
import { ConfirmationModalComponent, ModalComponent } from "@app/shared/components";
import * as LiftActions from '@app/lift/store/lifts.actions';
import { Lift } from "@app/shared/models/lift.model";
import { Tray } from "@app/shared/models/tray.model";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Slot } from "@app/shared/models/slot.model";

@Component({
  selector: "app-copy-slot-modal",
  templateUrl: "./copy-slot-modal.component.html",
  styleUrls: ["./copy-slot-modal.component.scss"],
})
export class CopySlotModalComponent implements OnInit {
  @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;
  @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;

  @Input() slot: Slot;
  @Input() showValidations = false;
  @Input() isLoading: boolean;

  liftForm: UntypedFormGroup;
  trayForm: UntypedFormGroup;

  selectedLift: Lift = null;
  selectedTray: Tray = null;

  lifts: Lift[] = [];
  trays: Tray[] = [];

  initialLiftId: number;
  initialTrayId: number;

  ngOnInit() {
    this.liftForm = new UntypedFormGroup({
      lift: new UntypedFormControl(this.selectedLift, [
        Validators.required
      ]),
    });

    this.trayForm = new UntypedFormGroup({
      tray: new UntypedFormControl(this.selectedTray, [
        Validators.required
      ]),
    });
  }

  constructor(
    private liftsService: LiftsService,
    private store: Store<any>,
    private translate: TranslateService
  ) {}

  public loadLiftFormValue() {
    this.liftForm.setValue({
      lift: this.selectedLift,
    });
  }

  public loadTrayFormValue() {
    this.trayForm.setValue({
      tray: this.selectedTray,
    });
  }

  getFormValue() {
    return {lift: this.liftForm.value.lift, tray: this.trayForm.value.tray};
  }

  onSelectLift(lift: Lift) {
    this.selectedTray = null;
    this.loadTrayFormValue();
    this.loadTrayFormValue(); // resets only if function called twice...

    if (!lift) { return; }
    this.liftsService.getLift(lift.id).subscribe((data) => {
      this.selectedLift = data as Lift;
      this.trays = this.selectedLift.trays;
    });
  }

  onSelectTray(tray: Tray) {
    if (!tray) { return; }
    this.selectedTray = tray;
  }

  onSubmit() {
    if (this.liftForm.valid && this.trayForm.valid) {
      this.modal.close();
      this.confirmationModal.open();
    }
  }

  public onConfirm() {
    this.confirmationModal.close();
    this.store.dispatch(
      new LiftActions.CopySlotAction(
        this.initialLiftId,
        this.initialTrayId,
        this.selectedLift.id,
        this.selectedTray.id,
        this.slot.id
      )
    );
  }

  onCancel() {
    this.close();
  }

  public close() {
    this.modal.close();
  }

  public open(slot: Slot, initialLiftId: number, initialTrayId: number) {
    this.reset();
    this.getLifts();
    this.slot = slot;
    this.initialLiftId = initialLiftId;
    this.initialTrayId = initialTrayId;
    this.modal.open();
  }

  private reset() {
    this.selectedLift = null;
    this.selectedTray = null;
    this.trays = [];
    this.loadLiftFormValue();
    this.loadTrayFormValue();
  }

  private getLifts() {
    this.liftsService.getLifts().subscribe((data) => {
        this.lifts = (data as any).items;
        // Remove current lift
        if (this.initialLiftId) {
          const index = this.lifts.indexOf(this.lifts.find((lift) => lift.id === this.initialLiftId));
          this.lifts.splice(index, 1);
        }
        this.loadLiftFormValue();
    });
  }
}
